import {
  dropBoolean,
  dropCusto,
  dropEstruturaLinhaProduto,
  dropIdSped,
  dropTipoItem,
} from 'utils/drops';

const getLinhaProdutoFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'linha', label: 'Linha' },
  { name: 'descricao', label: 'Descrição', initial: true },
  { name: 'servico', label: 'Serviço', type: 'select', options: dropBoolean },
  { name: 'processo', label: 'Processo', type: 'select', options: dropBoolean },
  {
    name: 'estrutura',
    label: 'Estrutura',
    type: 'select',
    options: dropEstruturaLinhaProduto,
    multiple: true,
  },
  {
    name: 'apontamento',
    label: 'Apontamento',
    type: 'select',
    options: dropBoolean,
  },
  {
    name: 'referencia',
    label: 'Referência',
    type: 'select',
    options: dropBoolean,
  },
  {
    name: 'obreferencia',
    label: 'Observação Referência',
    type: 'select',
    options: dropBoolean,
  },
  { name: 'sefazean', label: 'SEFAZ EAN', type: 'select', options: dropBoolean },
  {
    name: 'idsped',
    label: 'ID Sped',
    type: 'select',
    options: dropIdSped,
    multiple: true,
  },
  {
    name: 'custo',
    label: 'Custo',
    type: 'select',
    options: dropCusto,
    multiple: true,
  },
  {
    name: 'tipoitem',
    label: 'Tipo Item',
    type: 'select',
    options: dropTipoItem,
    multiple: true,
  },
  { name: 'ativo', label: 'Ativo', type: 'select', options: dropBoolean },
];

export default getLinhaProdutoFilterFields;
